import { ShippingRateProvince } from "../Model/ShippingRateProvince";
import { ShippingRepository } from "../Repository/ShippingRepository";

export interface GetShippingRatesProvinceUseCase {
    invoke: () => Promise<ShippingRateProvince[]>;
}

export class GetShippingRatesProvince implements GetShippingRatesProvinceUseCase {
    private shippingRepo: ShippingRepository;

    constructor(_shippingRepo: ShippingRepository) {
        this.shippingRepo = _shippingRepo;
    }

    invoke(): Promise<ShippingRateProvince[]> {
        return this.shippingRepo.getShippingRatesProvince();
    }
}